import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { WorkoutSessionProvider } from '../contexts/WorkoutSessionProvider';
import { useWorkoutMeta } from '../contexts/WorkoutMetaContext';
import LiveSession from '../components/workout/LiveSession';
import RoutinePicker from '../components/workout/RoutinePicker';

/* ════════════════════════════════════════════════════════════════
   <WorkoutPage />

   Thin shell: provider + branching between the two child views.

   • <RoutinePicker /> renders when there's no active workout. It
     owns the picker JSX (today's hero, week planner, routine
     wizard, personal routine editor, day preview, preferences
     sheet) and the startWorkout/startFromTemplate bridges.
   • <LiveSession /> always mounts. It returns null when nothing
     to show, but stays in the tree so the post-workout completion
     dialog persists across the activeWorkout=true→null transition.

   Heavier orchestration that used to live here was extracted in
   v3.8.165–v3.8.170 (Tasks 0–7 of the workout-page refactor):
   • Live-session UI + state → LiveSession.js
   • Set / exercise rows → SetRow.js, ExerciseRow.js
   • Pure helpers → liveSessionUtils.js
   • Provider stack → WorkoutSessionProvider.js + 3 contexts
   • Routine picker JSX → RoutinePicker.js  (this commit)
   • Inline WorkoutTimer component → WorkoutTimer.js  (this commit)
   ════════════════════════════════════════════════════════════════ */

function WorkoutPageInner() {
  const { activeWorkout } = useWorkoutMeta();
  return (
    <>
      {!activeWorkout && <RoutinePicker />}
      <LiveSession />
    </>
  );
}

export default function WorkoutPage() {
  const [searchParams] = useSearchParams();
  return (
    <WorkoutSessionProvider
      urlOnBehalfOf={searchParams.get('on_behalf_of')}
      urlClientName={searchParams.get('client_name')}
    >
      <WorkoutPageInner />
    </WorkoutSessionProvider>
  );
}
